import React from "react";
import Button from "@material-ui/core/Button";

class DialogButtons extends React.Component {
  renderActionButton = () => {
    if (this.props.connection.type === "public-rest-api") {
      if (this.props.editableContent.length > 0) {
        return (
          <Button onClick={this.props.onPublicAPIConnectClickEdit} color="primary" disabled={!this.props.administrator}>
            Update
          </Button>
        );
      }

      return (
        <Button
          onClick={this.props.onPublicAPIConnectClick}
          color="primary"
          disabled={this.props.enabled || this.props.buildTriggered}
        >
          Connect
        </Button>
      );
    }

    return (
      <Button
        onClick={this.props.onConnectClick}
        color="primary"
        disabled={this.props.enabled || this.props.buildTriggered}
      >
        Connect
      </Button>
    );
  };

  render() {
    return (
      <React.Fragment>
        <Button onClick={this.props.handleClose} color="primary">
          Cancel
        </Button>
        {this.renderActionButton()}
      </React.Fragment>
    );
  }
}

export default DialogButtons;
